import type { ConceptDef } from '../types';

export const turnTaking: ConceptDef = {
  kind: 'supervisorScored',
  id: 'turn-taking',
  label: 'Turn-Taking',
  category: 'Social',
  description: 'Run a turn-taking round; supervisor scores cooperation.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Roll the ball back and forth — your turn.' },
      { prompt: 'Stack one block each, taking turns.' },
      { prompt: 'Take turns coloring one square at a time.' },
      { prompt: 'Wait for the supervisor to clap, then you clap.' },
    ],
  },
};
